
import { Vue, Component, Prop } from "vue-property-decorator";
import ebButton from "@/components/FormElements/Button.vue";
@Component ({
  components: {
   ebButton
  }
}) 
export default class Create extends Vue {
  private name: string = "";
  private description: string = "";

  private createNewRole() {
    this.$emit("newRole", { name: this.name, description: this.description });
  }
}
